export default "__VITE_ASSET__Bl9iZTO5__"